import { ANNOUNCEMENT_MODE } from 'containers/ClanLanding/components/AnnouncementsCard/constants'

import {
    ANNOUNCEMENTS_CHANGE_MODE,
    ANNOUNCEMENTS_OPENED_ID,
    ANNOUNCEMENTS_REQUEST,
    ANNOUNCEMENTS_SUCCESS,
    ANNOUNCEMENTS_ERROR,
    ANNOUNCEMENTS_LIST,
    ANNOUNCEMENTS_SETTINGS,
    ANNOUNCEMENTS_CLEAR_DATA,
} from 'state/actions/announcements'

const initialState = {
    prevMode: null,
    mode: ANNOUNCEMENT_MODE.CARD,

    openedAnnouncement: null,

    isLoading: false,

    list: [],
    settings: {},

    error: null,
}

export default function reducer(state = initialState, { type, payload }) {
    switch (type) {
    case ANNOUNCEMENTS_CHANGE_MODE:
        return {
            ...state,
            prevMode: state.mode,
            mode: payload,
        }
    case ANNOUNCEMENTS_OPENED_ID:
        return {
            ...state,
            openedAnnouncement: payload,
        }
    case ANNOUNCEMENTS_CLEAR_DATA:
        return {
            ...state,
            list: [],
            settings: {},
        }
    case ANNOUNCEMENTS_REQUEST:
        return {
            ...state,
            isLoading: true,
        }
    case ANNOUNCEMENTS_SUCCESS:
        return {
            ...state,
            isLoading: false,
            error: null,
        }
    case ANNOUNCEMENTS_ERROR:
        return {
            ...state,
            isLoading: false,
            error: payload,
        }
    case ANNOUNCEMENTS_LIST:
        return {
            ...state,
            list: payload,
        }
    case ANNOUNCEMENTS_SETTINGS:
        return {
            ...state,
            settings: payload,
        }
    default: return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/announcements.js